// src/components/Header.js
import React from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TikTokIcon from './TikTokIcon';

const Header = () => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const navItems = [
    { label: 'Home', path: '/' },
    { label: 'Menu', path: '/menu' },
    { label: 'Catering', path: '/catering' },
  ];

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  // Mobile header: Hamburger on left, logo centered.
  if (isMobile) {
    return (
      <>
        <AppBar position="static" sx={{ backgroundColor: '#000', boxShadow: '0 3px 5px rgba(0,0,0,0.5)' }}>
          <Toolbar
            sx={{
              position: 'relative',
              justifyContent: 'center',
              alignItems: 'center',
              px: 2,
              minHeight: '56px',
            }}
          >
            <IconButton sx={{ position: 'absolute', left: 0 }} onClick={toggleDrawer(true)}>
              <MenuIcon sx={{ fontSize: 30, color: '#fff' }} />
            </IconButton>
            <Link to="/">
              <img src="/lfbbq.png" alt="Left Field BBQ logo" style={{ width: '200px' }} />
            </Link>
          </Toolbar>
        </AppBar>
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={toggleDrawer(false)}
          PaperProps={{ sx: { background: 'linear-gradient(to bottom, #1c1c1c, #333)' } }}
        >
          <Box
            sx={{
              width: '250px',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
          >
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
              <IconButton onClick={toggleDrawer(false)}>
                <CloseIcon sx={{ fontSize: 30, color: '#fff' }} />
              </IconButton>
            </Box>
            <List>
              {navItems.map((item) => (
                <ListItem key={item.label} disablePadding>
                  <ListItemButton component={Link} to={item.path}>
                    <ListItemText
                      primary={item.label}
                      primaryTypographyProps={{ sx: { color: '#fff', fontSize: '25px', fontFamily: '"Audiowide", sans-serif' } }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 'auto', mb: 2 }}>
              <IconButton href="https://instagram.com/leftfieldbbq/" aria-label="Follow us on Instagram" target="_blank" rel="noopener noreferrer" sx={{ color: '#fff' }}>
                <InstagramIcon sx={{ fontSize: 32 }} />
              </IconButton>
              <IconButton href="https://www.facebook.com/LeftFieldBBQ/" aria-label="Follow us on Facebook" target="_blank" rel="noopener noreferrer" sx={{ color: '#fff' }}>
                <FacebookIcon sx={{ fontSize: 32 }} />
              </IconButton>
              <IconButton href="https://tiktok.com/@leftfieldbbqllc/" aria-label="Follow us on TikTok" target="_blank" rel="noopener noreferrer" sx={{ color: '#fff' }}>
                <TikTokIcon sx={{ fontSize: 32 }} />
              </IconButton>
            </Box>
          </Box>
        </Drawer>
      </>
    );
  }

  // Desktop header: Left section (logo), center (navigation)
  return (
    <AppBar position="static" sx={{ backgroundColor: '#000', boxShadow: '0 3px 5px rgba(0,0,0,0.5)' }}>
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: '64px',
          width: '100%',
          maxWidth: '1200px',
          mx: 'auto',
          px: 2,
        }}
      >
        {/* Left: Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', pl: 2 }}>
          <Link to="/">
            <img src="/lfbbq.png" alt="Left Field BBQ logo" style={{ width: '200px' }} />
          </Link>
        </Box>
        {/* Center: Navigation */}
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          {navItems.map((item) => (
            <Button
              key={item.label}
              component={Link}
              to={item.path}
              sx={{
                fontSize: '25px',
                color: '#fff',
                textTransform: 'none',
                mx: 2,
                // Override header buttons to use Audiowide.
                fontFamily: '"Audiowide", sans-serif',
                '&:hover': {
                  color: '#72faff',
                  borderBottom: '2px solid #72faff',
                },
              }}
            >
              {item.label}
            </Button>
          ))}
        </Box>
        {/* Right: Spacer */}
        <Box sx={{ width: '200px', pr: 2 }} />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
